<tran-application-detail-dashboard-box [heading]="heading()">
    @if (isLoading()) {
        <tran-pill-table aria-hidden="true">
            <tran-pill-header-row rowClasses="min-h-[20px]" class="!font-normal !text-sm text-secondary">
                <tran-pill-header-cell bgColor="bg-transparent">
                    <span class="si-skeleton w-full"></span>
                </tran-pill-header-cell>
                <tran-pill-header-cell bgColor="bg-transparent">
                    <span class="si-skeleton w-full"></span>
                </tran-pill-header-cell>
            </tran-pill-header-row>
            @for (skeletonBudgetIdx of [0, 1]; track skeletonBudgetIdx) {
                <tran-pill-row rowClasses="min-h-[44px]">
                    <tran-pill-cell bgColor="bg-deep-blue-800">
                        <span class="si-skeleton w-full"></span>
                    </tran-pill-cell>
                    <tran-pill-cell bgColor="bg-deep-blue-750">
                        <span class="si-skeleton w-full"></span>
                    </tran-pill-cell>
                </tran-pill-row>
            }
            <tran-pill-row rowClasses="min-h-[44px] pt-2 font-bold">
                <tran-pill-cell bgColor="bg-deep-blue-800">
                    <span class="si-skeleton w-full"></span>
                </tran-pill-cell>
                <tran-pill-cell bgColor="bg-deep-blue-750">
                    <span class="si-skeleton w-full"></span>
                </tran-pill-cell>
            </tran-pill-row>
        </tran-pill-table>
    } @else if (readonly()) {
        <tran-pill-table>
            <tran-pill-header-row rowClasses="min-h-[20px]" class="!font-normal !text-sm text-secondary">
                <tran-pill-header-cell bgColor="bg-transparent">
                    {{ 'components.application-detail-dashboard.application-detail-budget.fiscal-year' | translate }}
                </tran-pill-header-cell>
                <tran-pill-header-cell bgColor="bg-transparent">
                    {{ 'components.application-detail-dashboard.application-detail-budget.amount' | translate }}
                </tran-pill-header-cell>
            </tran-pill-header-row>
            @for (budgetEntry of budgets(); let index = $index; track index) {
                <tran-pill-row rowClasses="min-h-[44px]">
                    <tran-pill-cell bgColor="bg-deep-blue-800">
                        <span class="p-1">FY {{ budgetEntry.fiscalYear }}</span>
                    </tran-pill-cell>
                    <tran-pill-cell bgColor="bg-deep-blue-750">
                        <span class="p-1">{{ budgetEntry.amount | currency: 'EUR' : 'symbol' : '1.0-2' }}</span>
                    </tran-pill-cell>
                </tran-pill-row>
            }

            <tran-pill-row rowClasses="min-h-[44px] pt-2 font-bold">
                <tran-pill-cell bgColor="bg-deep-blue-800">
                    <span class="p-1">
                        {{ 'components.application-detail-dashboard.application-detail-budget.sum' | translate }}</span
                    >
                </tran-pill-cell>
                <tran-pill-cell bgColor="bg-deep-blue-750">
                    <span class="p-1">{{ totalBudget() | currency: 'EUR' : 'symbol' : '1.0-2' }}</span>
                </tran-pill-cell>
            </tran-pill-row>
        </tran-pill-table>
    } @else {
        <tran-budgets [control]="control()!" />
    }
</tran-application-detail-dashboard-box>
